import 'reflect-metadata';
import './services/pixel-convolution-service';
import './services/ink-drawer-service';
import './load-sound';
import './play-sound';
import './metallic-sound';
import './outline';
import './script';
